import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';

import { NewStyleColor } from '../../utils/styles-constants';

interface WrapperProps {
	hasUsers: boolean;
}

const Wrapper = styled('div')`
	box-sizing: border-box;
	padding: 20px;

	${({ hasUsers }: WrapperProps) => hasUsers && 'min-height: 117px;'}
`;

const Message = styled(Translate)`
	display: block;
	text-align: center;
`;

const UserName = styled('div')`
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;

const UserEmail = styled('div')`
	margin-top: 5px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	color: ${NewStyleColor.Grey600};
`;

export {
	Wrapper,
	Message,
	UserName,
	UserEmail,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ShareWithUserPopup/styles.ts